import { z } from "zod"
import { BackofficeSupportIntegrationEnum } from "./dtos"

export const BackofficeSupportQuestionResponseDataSchema = z.object({
  id: z.bigint().transform(String),
  organizationId: z.bigint().transform(String),
  conversationId: z.bigint().transform(String),
  customerId: z.bigint().transform(String),
  subject: z.string().nullable(),
  summary: z.string(),
  category: z.string().nullable(),
  externalCategory: z.string().nullable(),
  automaticallySolved: z.boolean(),
  hasTicket: z.boolean(),
  hasAmphoraTicketIntegration: z.boolean(),
  externalId: z.string().nullable(),
  createdAt: z.date().transform((d) => d.toISOString()),
  integrations: z.array(z.enum(BackofficeSupportIntegrationEnum)),
  company: z.object({
    id: z.bigint().transform(String),
    name: z.string(),
    logo: z.string().nullable(),
  }),
})

export const BackofficeSupportQuestionsResponseDataSchema = z.array(
  BackofficeSupportQuestionResponseDataSchema,
)
